import {
    CREATE_GENERAL_DC_FAILURE_DK,
    CREATE_GENERAL_DC_REQUEST_DK,
    CREATE_GENERAL_DC_SUCCESS_DK,
    CREATE_USER_FORM_GENERAL_DC_DK,
    FETCH_SINGLE_GENERAL_DC_FAILURE_DK,
    FETCH_SINGLE_GENERAL_DC_REQUEST_DK,
    FETCH_SINGLE_GENERAL_DC_SUCCESS_DK,
    FETCH_GENERAL_DC_FAILURE_DK,
    FETCH_GENERAL_DC_REQUEST_DK,
    FETCH_GENERAL_DC_SUCCESS_DK,
    NAVIGATE_GENERAL_DC_DETAILS_DK,
    NAVIGATE_GENERAL_DC_DK,
    GENERAL_DC_USERFORM_RESET_DK,
    UPDATE_GENERAL_DC_FAILURE_DK,
    UPDATE_GENERAL_DC_REQUEST_DK,
    UPDATE_GENERAL_DC_SUCCESS_DK,
    DELETE_GENERAL_DC_REQUEST_DK,
    DELETE_GENERAL_DC_SUCCESS_DK,
    DELETE_GENERAL_DC_FAILURE_DK,
    GENERAL_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK,
    GENERAL_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK,
    FETCH_GENERAL_DC_INVOICE_REQUEST,
    FETCH_GENERAL_DC_INVOICE_SUCCESS,
    FETCH_GENERAL_DC_INVOICE_FAILURE,
    RESET_GENERAL_DC_INVOICE,
    FETCH_GENERAL_DC_STYLE_REQUEST_DK,
    FETCH_GENERAL_DC_STYLE_SUCCESS_DK,
    FETCH_GENERAL_DC_STYLE_FAILURE_DK,
} from './generalDC.actionsType';

export const GENERAL_DC_DK = 'generalDCDK';

let initialState = {
    loading: false,
    generalDC: [],
    generalDCInvoice:[],
    generalDcStyleList:[],
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldItemsTotalValue: 0,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldRoundoff: 0
    },
    selectedTeam: {},
    detailsId: '',
    activeKey: 1,
    isGeneralDC: false,
    generalDCSelectedValue: null,
    errorMessage: '',
    iperrorMessage: ''
};

export let generalDCDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_GENERAL_DC_REQUEST_DK:
        case FETCH_GENERAL_DC_STYLE_REQUEST_DK:
        case FETCH_GENERAL_DC_INVOICE_REQUEST:
        case CREATE_GENERAL_DC_REQUEST_DK:
        case FETCH_SINGLE_GENERAL_DC_REQUEST_DK:
        case UPDATE_GENERAL_DC_REQUEST_DK:
        case DELETE_GENERAL_DC_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_GENERAL_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalDC: updatePayload
            };
            case FETCH_GENERAL_DC_INVOICE_SUCCESS:
                return {
                    ...state,
                    loading: false,
                    generalDCInvoice: updatePayload
                };
        case CREATE_GENERAL_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: updatePayload
            };
            case FETCH_GENERAL_DC_STYLE_SUCCESS_DK:
                return {
                    ...state,
                    loading: false,
                    generalDcStyleList: updatePayload
                };
        case FETCH_SINGLE_GENERAL_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedTeam: updatePayload,
                userform: updatePayload
            };
        case UPDATE_GENERAL_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case DELETE_GENERAL_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case FETCH_GENERAL_DC_FAILURE_DK:
        case FETCH_GENERAL_DC_STYLE_FAILURE_DK:
        case FETCH_GENERAL_DC_INVOICE_FAILURE:
        case FETCH_SINGLE_GENERAL_DC_FAILURE_DK:
        case CREATE_GENERAL_DC_FAILURE_DK:
        case UPDATE_GENERAL_DC_FAILURE_DK:
        case DELETE_GENERAL_DC_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_GENERAL_DC_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case GENERAL_DC_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_GENERAL_DC_DETAILS_DK:
            return {
                ...state,
                isGeneralDC: true,
                generalDCSelectedValue: updatePayload.generalDCSelectedValue
            };
        case NAVIGATE_GENERAL_DC_DK:
            return {
                ...state,
                isGeneralDC: false
            };
            case RESET_GENERAL_DC_INVOICE:
                return {
                    ...state,
                    generalDCInvoice: []
                };
        case GENERAL_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 2
            };
        case GENERAL_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
